export interface IApplicationState {

    showSettingPanel: boolean;
    spaceBarSpin: boolean,
    turboToggle: boolean,
    fullScreenToggle: boolean,
}

const initialState: IApplicationState = {
    showSettingPanel: false,
    spaceBarSpin: false,
    turboToggle: false,
    fullScreenToggle: false,


};

export enum actionTypes {

    SHOW_SETTING_PANEL = '@@desktopSettingPanel/SHOW_SETTING_PANEL',
    SPACE_BAR_SPIN = '@@desktopSettingPanel/SPACE_BAR_SPIN',
    TURBO_TOGGLE = '@@desktopSettingPanel/TURBO_TOGGLE',
    FULL_SCREEN_TOGGLE = '@@desktopSettingPanel/FULL_SCREEN_TOGGLE',

}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const {showSettingPanel, spaceBarSpin, turboToggle, fullScreenToggle} = action;

    switch (action.type) {
        case actionTypes.SHOW_SETTING_PANEL:
            return {
                ...state, showSettingPanel: showSettingPanel,
            };
        case actionTypes.SPACE_BAR_SPIN:
            return {
                ...state, spaceBarSpin: spaceBarSpin,
            };
        case actionTypes.TURBO_TOGGLE:
            return {
                ...state, turboToggle: turboToggle,
            };
        case actionTypes.FULL_SCREEN_TOGGLE:
            return {
                ...state, fullScreenToggle: fullScreenToggle,
            };
        default:
            return state;
    }
}

export const actions = {
    showDesktopSettingPanelUI: (showSettingPanel: boolean): any => ({
        type: actionTypes.SHOW_SETTING_PANEL,
        showSettingPanel
    }),
    spinWithSpaceBar: (spaceBarSpin: boolean): any => ({type: actionTypes.SPACE_BAR_SPIN, spaceBarSpin}),
    turboToggleButton: (turboToggle: boolean): any => ({type: actionTypes.TURBO_TOGGLE, turboToggle}),
    fullScreenToggleButton: (fullScreenToggle: boolean): any => ({
        type: actionTypes.FULL_SCREEN_TOGGLE,
        fullScreenToggle
    }),


};



